'use strict';

/* global $ */

class Cookie {
    constructor(options) {
        this.opt = $.extend({}, {}, options);

	    // cookie, которые будем использовать
	    this.utm = {
	        utm_source: '',
	        utm_campaign: '',
	        utm_medium: '',
	        type: '',
	        source: '',
	        block: '',
	        keyword: '',
	        addphrase: '',
	    };

        this.init();
    }
    init() {
		var params = this.URLParamsParser(window.location.search.substring(1));

	    this.cookies(params);

    }

    URLParamsParser(sParam) {
        var sPageURL = decodeURIComponent(sParam), // все параметры
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            sParameterObject,
            sResult = [],
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            sParameterObject = {};
            sParameterObject[sParameterName[0]] = sParameterName[1] || 0;
            $.extend(sResult, sParameterObject);
        }

        return sResult;
    }

    cookies(UTMparams) {
		let cookiecook = getCookie('cookiecook');
		let cookiesBlock = $('.js-cookies');
		if (cookiecook != 'no') {
			cookiesBlock.show();
			cookiesBlock.find('.js-cookies__btn').on('click', function(e) {
				e.preventDefault();
				cookiesBlock.hide();
		        let cookieOptions = {
		            'path': '/',
		            'max-age': 60*60*24*7, // 1 week
		        };
				setCookie('cookiecook', 'no', cookieOptions);
			});
		}

        var __cookies = $('input[name="utm"]');
        var __undefCookies = $('#__undefCookies');
        var cookieOptions = {
            'path': '/',
            'max-age': 60*60*24*30, // 1 month
        };
        var paramString  = '';

        // если есть ID, который говорит нам о том, что куки нужно удалить, то удаляем
        if (__undefCookies.length) {

            for (var paramName in this.utm) {
                deleteCookie(paramName);
            }

            return 0;
        }

        // если есть UTM метки в адресной строке, добавим их в куки
        if (Object.keys(UTMparams).length && UTMparams['utm_campaign']) {

            for (var paramName in UTMparams) {
                setCookie(paramName, UTMparams[paramName], cookieOptions);
                paramString += paramName + '=' + UTMparams[paramName] + '; ';
            }

        } 

        // если есть UTM метки в куках и мы на странице с формой, то запишем в инпут наши метки, чтобы отдать их серверу
        if (__cookies.length && checkCookie('utm_campaign') ) {

            for (var paramName in this.utm) {
                paramString += paramName + '=' + getCookie(paramName) + '; ';
            }

            __cookies.attr('value', paramString);
        }

        function checkCookie(cookieName) {
            if (typeof getCookie(cookieName) === 'undefined' ) {
                return 0;
            }

            return 1;
        }

        function setCookie(cookieName, cookieValue, cookieOptions) {
          cookieOptions = cookieOptions || {};

          var expires = cookieOptions.expires;

          if (typeof expires == "number" && expires) {
            var d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = cookieOptions.expires = d;
          }

          if (expires && expires.toUTCString) {
            cookieOptions.expires = expires.toUTCString();
          }

          cookieValue = encodeURIComponent(cookieValue);

          var updatedCookie = cookieName + "=" + cookieValue;

          for (var propName in cookieOptions) {
            updatedCookie += "; " + propName;
            var propValue = cookieOptions[propName];
            if (propValue !== true) {
              updatedCookie += "=" + propValue;
            }
          }

          document.cookie = updatedCookie;
        }

        function getCookie(cookieName) {
            if (typeof cookieName !== 'undefined' && cookieName !== null) {
                var matches = document.cookie.match(new RegExp(
                        "(?:^|; )" + cookieName.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
                    ));
                return matches ? decodeURIComponent(matches[1]) : undefined;
            }
        }

        function deleteCookie(name) {

          setCookie(name, "", {
            expires: 'Thu, 01 Jan 1970 00:00:01 GMT',
            path: '/',
            "max-age": 0,
          });

        }
    }
}


export {
    Cookie
};
